import { AdministratorDto } from '@/src/models/AdministratorDto';

export type FaqCategory =
  | '수거신청'
  | '앱 이용'
  | '탄소중립크레딧'
  | '크레딧 사용'
  | '기부하기'
  | '응모하기'
  | '챌린지'
  | '커뮤니티';

export default class FaqDto {
  id: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
  title: string;
  contents: string;
  showedYn: boolean;
  faqCategoryType: FaqCategory;
  serviceType: 'EARTH_APP';
  administrator: AdministratorDto;
}
